// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DataLastUpdated-module__LastUpdated__Item--QDzDE:not(:last-child){margin-right:4px}`, "",{"version":3,"sources":["webpack://./src/components/data-last-updated/DataLastUpdated.module.scss"],"names":[],"mappings":"AAEI,mEACE,gBAAA","sourcesContent":[".LastUpdated {\n  &__Item {\n    &:not(:last-child) {\n      margin-right: 4px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export var LastUpdated__Item = `DataLastUpdated-module__LastUpdated__Item--QDzDE`;
export default ___CSS_LOADER_EXPORT___;
